import { render, staticRenderFns } from "./Zones.vue?vue&type=template&id=39608e98&scoped=true"
import script from "./Zones.vue?vue&type=script&lang=js"
export * from "./Zones.vue?vue&type=script&lang=js"
import style0 from "./Zones.vue?vue&type=style&index=0&id=39608e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39608e98",
  null
  
)

export default component.exports